import type { I18nText } from "./locales";

/**
 * 头像框名册（cfg_frame，版本内，整表替换）。
 *
 * 这一页只是名册：玩家要通过奖励项 kind=frame（成就 / 邮件 / 通关 / 集齐奖励）拿到才能戴（Soui 2026-09-15），
 * 启用即可戴，不发放、不进玩家资产。停用一个框 = 戴着它的人展示回落到没戴，玩家行不动。
 * 界面模型直接就是接口形状（同加入我们渠道）。
 */
export interface AvatarFrame {
  /** 框标识，客户端设置时传它。整表替换里它当主键，改它 = 换一个框（戴着旧 id 的人会变成没戴） */
  frameId: string;
  /** 基准语言名，值始终跟着 nameI18n.en 走 */
  name: string;
  nameI18n: I18nText;
  /** 框图 URL，走上传管线；启用的框发布时必须有图 */
  image: string;
  sortOrder: number;
  enabled: boolean;
}

/** 与服务端 putFrames 的上限同一个数 */
export const FRAME_MAX = 200;

/** 与服务端 CODE_RE 同一条正则 */
const ID_RE = /^[a-z][a-z0-9_-]{0,63}$/;

// 展示顺序与服务端 ORDER BY sort_order, frame_id 一致
export const sortFrames = (xs: AvatarFrame[]): AvatarFrame[] =>
  [...xs].sort((a, b) => a.sortOrder - b.sortOrder || a.frameId.localeCompare(b.frameId));

export const newFrame = (xs: AvatarFrame[]): AvatarFrame => ({
  frameId: "", name: "", nameI18n: {}, image: "",
  sortOrder: xs.reduce((m, f) => Math.max(m, f.sortOrder), 0) + 1,
  enabled: true,
});

export type FrameIdIssue = "fr.issue.id" | "fr.issue.dup";
export function frameIdIssue(f: AvatarFrame, all: AvatarFrame[]): FrameIdIssue | null {
  if (!ID_RE.test(f.frameId)) return "fr.issue.id";
  if (all.filter((x) => x.frameId === f.frameId).length > 1) return "fr.issue.dup";
  return null;
}
